import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface DeleteConfirmationModelProps {
  onDelete: () => void;
  open: boolean;
  onClose: () => void;
}

export const DeleteConfirmationModel = ({
  open,
  onClose,
  onDelete,
}: DeleteConfirmationModelProps) => {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm MFA Deletion</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete your current MFA method? Geoscape
            recommends you protect your account with MFA. You can setup MFA
            again later from your account settings.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button variant="destructive" className="w-full" onClick={onDelete}>
            Delete MFA
          </Button>
          <Button variant="outline" className="w-full" onClick={onClose}>
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
